import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Device, TableAction, TableHeader, Tag, TeltonikaDevice, TeltonikaTaskState } from '@huge-monorepo/shared/interfaces';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationTabConfig, SideTagConfig, TableComponent } from '@huge-monorepo/shared/components';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { DialogService } from '@huge-monorepo/shared/services';
import { FilterItem, GenericTableHeaderComponent, GenericTableHeaderOptions, SortItem } from '@huge-monorepo/shared/components';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TeltonikaTaskPollingModalComponent } from '../modals/teltonika-task-polling-modal/teltonika-task-polling-modal.component';
import { TeltonikaExecuteTaskModalComponent } from '../modals/teltonika-execute-task-modal/TeltonikaExecuteTaskModal.component';
import { TeltonikaCreateReportModalComponent } from '../modals/teltonika-create-report/TeltonikaCreateReportModal.component';
import { map, Observable } from 'rxjs';
import { SharedToolsService } from '@huge-monorepo/shared/tools';
import { SharedGenericSingletonService, SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { ICustomerGenericService, IHIPGenericService, ICustomerTeltonikaService, IHIPTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { TeltonikaFilters } from 'libs/shared/src/interfaces/TeltonikaFilters';

@Component({
  imports: [CommonModule, ToolsModule, MaterialModule, GenericTableHeaderComponent],
  templateUrl: './teltonika-manage-tag-devices.component.html',
  styleUrl: './teltonika-manage-tag-devices.component.scss',
  standalone: true,
})
export class TeltonikaManageTagDevicesComponent implements OnInit {
  constructor(private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private activatedRouter: ActivatedRoute,
    private sharedGenericService: SharedGenericSingletonService<ICustomerGenericService | IHIPGenericService>,
    private router: Router,
    private tools: SharedToolsService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private toastr: ToastrService,) {

  }

  teltonikaService = this.sharedTeltonikaService.getService();
  /*TAB MANAGEMENT*/
  currentTab: string = "Manage Devices in Tag";

  tabConfig: NavigationTabConfig[] = [
    { title: "Manage Devices in Tag" },
    { title: "View Tag Devices" }
  ];
  navLoading: boolean = false;

  changeTab(tab: string) {
    this.selectedDevices = [];
    this.selectedDevicesSubset = [];
    this.unselectedDevicesSubset = [];
    this.DevicesToBeAddedToTag = [];
    this.DevicesToBeRemovedFromTag = [];
    this.searchTerm = '';

    this.currentTab = tab;
    if (tab === "Manage Devices in Tag") {
      this.fetchTagData(this.id);
    }
  }

  /*MANAGE DEVICES IN TAG TAB*/
  @ViewChild('allDevicesTable') allDevicesTable: TableComponent;
  @ViewChild('tagDevicesTable') tagDevicesTable: TableComponent;
  @ViewChild('scrollContainerAllDevices') scrollContainerAllDevices: ElementRef;
  @ViewChild('scrollContainerSelectedDevices') scrollContainerSelectedDevices: ElementRef;

  SelectedTag: Tag | null = null;
  Devices: Device[] = [];
  loading: boolean = false;
  unselectedDevicesData: Device[] = [];
  selectedDevicesData: Device[] = [];
  DevicesToBeAddedToTag: Device[] = [];
  DevicesToBeRemovedFromTag: Device[] = [];
  unselectedDevicesSubset: Device[] = [];
  selectedDevicesSubset: Device[] = [];

  loadedBlockSize: number = 100;

  unselectedTablesSearchFn = (search: string, data: any): any[] => {
    return this.unselectedDevicesData.filter(device => (device.TeltonikaCustomName != null && device.TeltonikaCustomName.toLowerCase().includes(search.toLowerCase())) || device.name.toLowerCase().includes(search.toLowerCase()) || device.customerReference?.toLowerCase().includes(search.toLowerCase()));
  }

  selectedTablesSearchFn = (search: string, data: any): any[] => {
    return this.selectedDevicesData.filter(device => (device.TeltonikaCustomName != null && device.TeltonikaCustomName.toLowerCase().includes(search.toLowerCase())) || device.name.toLowerCase().includes(search.toLowerCase()) || device.customerReference?.toLowerCase().includes(search.toLowerCase()));
  }

  unselectedTableClearFn = (): any[] => {
    this.unselectedDevicesSubset = this.unselectedDevicesData.slice(0, this.loadedBlockSize);
    this.allDevicesTable.setSelection(this.DevicesToBeAddedToTag);
    return this.unselectedDevicesSubset;
  }

  selectedTableClearFn = (): any[] => {
    this.selectedDevicesSubset = this.selectedDevicesData.slice(0, this.loadedBlockSize);
    this.tagDevicesTable.setSelection(this.DevicesToBeRemovedFromTag);
    return this.selectedDevicesSubset;
  }

  selectDisabledFn = (row: any): boolean => {
    return (row.TeltonikaTag != null && row.TeltonikaTag.ID !== this.SelectedTag?.ID);
  }

  id: number;

  allDevicesHeader: TableHeader[] = [
    {
      ID: 'TeltonikaCustomName',
      Index: 0,
      Sort: 'TeltonikaCustomName',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'DeviceNum',
      Index: 1,
      Sort: 'name',
      Sortable: false,
      Text: 'Serial',
      Type: String,
      Align: 'left',
    },
    {
      ID: "customerReference",
      Index: 2,
      Sort: 'customerReference',
      Sortable: false,
      Text: 'Company Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: "TeltonikaTag",
      Index: 3,
      Sort: 'TeltonikaTag',
      Sortable: false,
      Text: 'Tag',
      Type: String,
      Align: 'left',
      Wrapper: (data) => {
        if (data.TeltonikaTag != null) {
          return data.TeltonikaTag.Name;
        }
        return null;
      }
    }
  ];

  selectedDevicesHeader: TableHeader[] = [
    {
      ID: 'TeltonikaCustomName',
      Index: 0,
      Sort: 'TeltonikaCustomName',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'name',
      Index: 1,
      Sort: 'name',
      Sortable: false,
      Text: 'Serial',
      Type: String,
      Align: 'left',
    },
    {
      ID: "customerReference",
      Index: 2,
      Sort: 'customerReference',
      Sortable: false,
      Text: 'Company Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: "TeltonikaTag",
      Index: 3,
      Sort: 'TeltonikaTag',
      Sortable: false,
      Text: 'Tag',
      Type: String,
      Align: 'center',
      Wrapper: (data) => {
        if (data.TeltonikaTag != null) {
          return data.TeltonikaTag.Name;
        }
        return null;
      }
    }
  ];

  ngOnInit(): void {
    this.activatedRouter.params.subscribe(params => {
      this.id = +params['id'];
      this.fetchTagData(this.id);
    });
  }

  fetchAllDevices() {
    this.teltonikaService.getTeltonikaDevices(null, -1, -1, null, null, null, null).subscribe({
      next: (data: Device[]) => {
        this.Devices = data;
        this.organizeDevices();
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  fetchTagData(id: number) {
    this.loading = true;
    this.teltonikaService.getTag(id).subscribe({
      next: (data: Tag) => {
        this.SelectedTag = data;
        this.fetchAllDevices();
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  organizeDevices() {
    if (this.Devices != null) {
      this.unselectedDevicesData = this.Devices.filter(device => !this.SelectedTag?.DeviceIDs.includes(device.id));
      this.unselectedDevicesSubset = this.unselectedDevicesData.slice(0, this.loadedBlockSize);
      this.selectedDevicesData = this.Devices.filter(device => this.SelectedTag?.DeviceIDs.includes(device.id));
      this.selectedDevicesSubset = this.selectedDevicesData.slice(0, this.loadedBlockSize);
    }
  }

  addDevicesToTag() {
    this.selectedDevicesData = this.selectedDevicesData.concat(this.DevicesToBeAddedToTag);
    this.unselectedDevicesData = this.unselectedDevicesData.filter(device => !this.DevicesToBeAddedToTag.includes(device));
    this.unselectedDevicesSubset = this.unselectedDevicesData.slice(0, this.loadedBlockSize);
    this.selectedDevicesSubset = this.selectedDevicesData.slice(0, this.loadedBlockSize);
    this.DevicesToBeAddedToTag = [];
    this.DevicesToBeRemovedFromTag = [];
    this.tagDevicesTable.setSelection([]);
    this.allDevicesTable.setSelection([]);
  }

  removeDevicesFromTag() {
    this.unselectedDevicesData = this.unselectedDevicesData.concat(this.DevicesToBeRemovedFromTag);
    this.selectedDevicesData = this.selectedDevicesData.filter(device => !this.DevicesToBeRemovedFromTag.includes(device));
    this.unselectedDevicesSubset = this.unselectedDevicesData.slice(0, this.loadedBlockSize);
    this.selectedDevicesSubset = this.selectedDevicesData.slice(0, this.loadedBlockSize);
    this.DevicesToBeRemovedFromTag = [];
    this.DevicesToBeAddedToTag = [];
    this.tagDevicesTable.setSelection([]);
    this.allDevicesTable.setSelection([]);
  }

  addSelectedFromAllDevices(devices: Device[]) {
    this.DevicesToBeAddedToTag = devices;

  }

  addSelectedFromTagDevices(devices: Device[]) {
    this.DevicesToBeRemovedFromTag = devices;
  }

  saveChanges() {
    this.loading = true;
    this.teltonikaService.updateTagDevices(this.SelectedTag?.ID, this.selectedDevicesData.map(device => device.id)).subscribe({
      next: (data) => {
        this.fetchTagData(this.id);
      },
      error: (err) => {
        console.error(err);
        this.sharedGenericService.service.createToast('Error', 'Error updating tag devices', 'error');
        this.loading = false;
      }
    });
  }

  allSelectedFromSelectedDevices($event: { toggled: boolean, list: Device[] }) {
    if (this.tagDevicesTable.searchTerm.value == null && $event.toggled) {
      this.DevicesToBeRemovedFromTag = this.selectedDevicesData.filter(device => {
        return (device.TeltonikaTag == null || device.TeltonikaTag.ID === this.SelectedTag?.ID)
      });
      this.tagDevicesTable.setSelection(this.DevicesToBeRemovedFromTag);
      return;
    }

    this.DevicesToBeRemovedFromTag = $event.list;
  }


  allSelectedFromUnselectedDevices($event: { toggled: boolean, list: Device[] }) {
    if (this.allDevicesTable.searchTerm.value == null && $event.toggled) {
      this.DevicesToBeAddedToTag = this.unselectedDevicesData.filter(device => {
        return (device.TeltonikaTag == null || device.TeltonikaTag.ID === this.SelectedTag?.ID)
      });

      this.allDevicesTable.setSelection(this.DevicesToBeAddedToTag);
      return;
    }
    this.DevicesToBeAddedToTag = $event.list;
  }

  deselectedFromUnselectedDevices($event: Device[]) {
    if (this.allDevicesTable.searchTerm.value == null) {
      this.DevicesToBeAddedToTag = [];
      this.allDevicesTable.setSelection([]);
      return;
    }
    this.DevicesToBeAddedToTag = this.DevicesToBeAddedToTag.filter(device => !$event.includes(device));
  }

  deselectedFromSelectedDevices($event: Device[]) {
    if (this.tagDevicesTable.searchTerm.value == null) {
      this.DevicesToBeRemovedFromTag = [];
      this.tagDevicesTable.setSelection([]);
      return;
    }
    this.DevicesToBeRemovedFromTag = this.DevicesToBeRemovedFromTag.filter(device => !$event.includes(device));
  }

  unselectedDevicesScrolled() {
    const container = this.scrollContainerAllDevices.nativeElement;

    const scrollTop = container.scrollTop; // Pixels scrolled from the top
    const scrollHeight = container.scrollHeight; // Total height of the scrollable content
    const clientHeight = container.clientHeight; // Visible height of the container

    const scrolledPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;

    if (scrolledPercentage > 95) {
      this.unselectedDevicesSubset = this.unselectedDevicesData.slice(0, this.unselectedDevicesSubset.length + this.loadedBlockSize);
    }
  }

  selectedDevicesScrolled() {
    const container = this.scrollContainerSelectedDevices.nativeElement;

    const scrollTop = container.scrollTop; // Pixels scrolled from the top
    const scrollHeight = container.scrollHeight; // Total height of the scrollable content
    const clientHeight = container.clientHeight; // Visible height of the container

    const scrolledPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
    if (scrolledPercentage > 95) {
      this.selectedDevicesSubset = this.selectedDevicesData.slice(0, this.selectedDevicesSubset.length + this.loadedBlockSize);
    }
  }

  /*VIEW TAG DEVICES TAB*/
  @ViewChild('devicesTable') devicesTable: TableComponent;
  selectedDevices: object[] = [];

  sortDesc: boolean = false;

  sortColumn: string = 'ID';

  searchTerm: string | null = '';


  firmwareFilters: string[] = [];
  modelFilters: string[] = [];
  statusFilters: string[] = [];

  appliedFilters: { Firmware: string | null, Model: string | null, DeviceStatus: string | null } = { Firmware: null, Model: null, DeviceStatus: null };

  allDevicesSelected: boolean = false;

  sideTagConfig: SideTagConfig = {
    PropertyID: 'TeltonikaStatus',
    ColourMapping: { 'Offline': 'red', 'Online': 'green', 'Action Required': 'orange', 'Unknown': 'grey', 'default': 'grey' },
    tooltipTextFn: (element) => {  // Assign the function directly
      let tooltipText = '';
      if (this.sideTagConfig.PropertyID == 'TeltonikaStatus') {
        tooltipText += 'Status: ' + `${element.TeltonikaStatus ?? 'Unknown'}`;
        if (element.TeltonikaStandardCheckInTimestamp) {
          tooltipText += '\n' + `Last Standard Check-In: ${this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(element.TeltonikaStandardCheckInTimestamp))}`;
        }

        if (element.TeltonikaReachableTimestamp) {
          tooltipText += '\n' + `Last Reachable: ${this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(element.TeltonikaReachableTimestamp))}`;
        }
      }
      return tooltipText;
    }
  };

  headers: TableHeader[] = [
    {
      ID: 'TeltonikaCustomName',
      Index: 0,
      Sort: 'TeltonikaCustomName',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
      Link: (device) => {
        this.router.navigate([`/Teltonika/Dashboard/device/${device.id}`]);
      },
    },

    {
      ID: 'DeviceType',
      Index: 1,
      Sort: 'deviceType',
      Sortable: false,
      Text: 'Model',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'TeltonikaSortTag',
      Index: 2,
      Sort: 'TeltonikaTag',
      Sortable: false,
      Text: 'Tag',
      Type: Object,
      Align: 'left',
      ObjectKey: 'Name'
    },
    {
      ID: 'CustomerReference',
      Index: 3,
      Sort: 'customerReference',
      Sortable: false,
      Text: 'Company Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'DeviceNum',
      Index: 4,
      Sort: 'name',
      Sortable: false,
      Text: 'Serial',
      Type: String,
      Align: 'left',
      Link: (device) => {
        this.router.navigate([`/Teltonika/Dashboard/device/${device.id}`]);
      },
    },
    {
      ID: 'MACAddress',
      Index: 5,
      Sort: 'MACAddress',
      Sortable: false,
      Text: 'MAC',
      Type: String,
      Align: 'left',
    },
  ];

  actions: TableAction[] = [
    {
      Icon: 'visibility',
      Text: 'View',
      Caller: (p: Device) => {
        this.router.navigate([`/Teltonika/Dashboard/device/${p.id}`]);
      },
    },
    {
      Icon: 'web',
      Text: 'Open HTTP Connection',
      Caller: (p: TeltonikaDevice) => {
        let ip: string = "";
        if (p.LastIP) {
          ip = p.LastIP;
        } else if (p.TeltonikaVPNIP) {
          ip = p.TeltonikaVPNIP;
        } else {
          this.sharedGenericService.service.createToast('Error', 'No IP address found', 'error');
          return;
        }

        this.teltonikaService.startTeltonikaTunneling(p.id, 80, ip).subscribe({
          next: (data) => {
            window.open(`http://${data}`, "_blank");
          },
          error: (error) => {
            this.sharedGenericService.service.createToast('Error', 'Failed to open HTTP tunnel', 'error');
          },
        });

      },
    },
    {
      Icon: 'key',
      Text: 'Open SSH Terminal',
      Caller: (p: TeltonikaDevice) => {
        let ip: string = "";
        if (p.LastIP) {
          ip = p.LastIP;
        } else if (p.TeltonikaVPNIP) {
          ip = p.TeltonikaVPNIP;
        } else {
          this.sharedGenericService.service.createToast('Error', 'No IP address found', 'error');
          return;
        }

        const url = this.router.serializeUrl(
          this.router.createUrlTree([`/Teltonika/terminal/${p.id}/${encodeURIComponent(ip)}`])
        );
        window.open(url, '_blank');
      },
    },
  ];

  showTable: boolean = true;


  headerFilterUpdate = (selection: { Name: string, Value: any }[]): Observable<FilterItem[]> => {
    const firmwareSearch = selection.find((f) => f.Name === "Firmware");
    const firmware = firmwareSearch != null && firmwareSearch.Value != null ? firmwareSearch.Value : null;
    const modelSearch = selection.find((f) => f.Name === "Model");
    const model = modelSearch != null && modelSearch.Value != null ? modelSearch.Value : null;
    const statusSearch = selection.find((f) => f.Name === "Status");
    const status = statusSearch != null && statusSearch.Value != null ? statusSearch.Value : null;
    return this.teltonikaService.getFilters(firmware, model, this.id, status).pipe(map((data: TeltonikaFilters) => {
      let newFilterItems: FilterItem[] = [];
      if (data != null) {
        if (data.Firmwares != null && data.Firmwares.length > 0) {
          newFilterItems.push({ Name: "Firmware", Values: data.Firmwares, DefaultValue: firmware });
        }
        if (data.Models != null && data.Models.length > 0) {
          newFilterItems.push({ Name: "Model", Values: data.Models, DefaultValue: model });
        }
        if (data.Statuses != null && data.Statuses.length > 0) {
          newFilterItems.push({ Name: "Status", Values: data.Statuses, DefaultValue: status });
        }
      }
      return newFilterItems;
    }));

  };

  headerConfig: GenericTableHeaderOptions = {
    ShowSearch: true,
    EnableExport: true,
    SearchPlaceholder: "Search Devices",
    SortItems: this.headers.map(h => {
      if (h.ID === "customerReference") {
        return ({ Display: h.Text, Name: 'Customer.Reference' } as SortItem)
      } else if (h.ID === "name") {
        return ({ Display: h.Text, Name: 'DeviceNum' } as SortItem)
      }
      return ({ Display: (h.ID !== "TeltonikaStatus" ? h.Text : "Status"), Name: h.ID } as SortItem)
    }),
    FilterItems: [{ Name: "Firmware", Values: this.firmwareFilters }, { Name: "Model", Values: this.modelFilters }, { Name: "Status", Values: this.statusFilters }],
    DynamicFilterUpdateFn: (selection: { Name: string, Value: any }[]) => this.headerFilterUpdate(selection)
  };

  setFilter(values: any) {

    this.showTable = false;

    if (values) {
      if (values.Search) {
        this.searchTerm = values.Search;
      } else {
        this.searchTerm = null;
      }

      if (values.Sort) {
        this.sortColumn = values.Sort;
        this.sortDesc = values.Desc;
      } else {
        this.sortColumn = "ID";
        this.sortDesc = values.Desc;

      }
      if (values.Filters) {
        let firmware: string | null = null;
        let model: string | null = null;
        let status: string | null = null;
        values.Filters.forEach((filter) => {
          if (filter.Name === "Firmware") {
            firmware = filter.value;
          } else if (filter.Name === "Model") {
            model = filter.value;
          } else if (filter.Name === "Status") {
            status = filter.value;
          }
        });
        this.appliedFilters = { Firmware: firmware, Model: model, DeviceStatus: status };

      }
    } else {
      this.searchTerm = '';
      this.sortColumn = "ID";
      this.sortDesc = false;
    }
    setTimeout(() => {
      this.allDevicesSelected = false;
      this.showTable = true;
    }, 0);
  }


  addSelected(e: object[]) {
    this.selectedDevices = e;
  }

  generateReport() {
    if (this.selectedDevices.length === 0 && this.allDevicesSelected === false) {
      this.toastr.error('No devices selected');
      return;
    }

    const dialogRef = this.dialog.open(TeltonikaCreateReportModalComponent, {
      width: '800px',
      data: { devices: JSON.parse(JSON.stringify(this.selectedDevices)), allSelected: this.allDevicesSelected }
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);

      if (result != null) {
        this.teltonikaService.exportReportingData(this.allDevicesSelected ? [] : result.DeviceIDs, result.Start, result.End, this.allDevicesSelected ? { TagID: this.id, Search: this.searchTerm == "" ? null : this.searchTerm, ...this.appliedFilters } : null).subscribe({
          next: (resp) => {
            this.toastr.success('Report Generated');
          },
          error: (err) => {
            this.toastr.error('Error generating report');
          }
        });
      }
    });
  }
  rebootDevices() {
    let selectedIds: number[] = [];
    if (this.allDevicesSelected) {
      selectedIds = this.Devices.map((device) => {
        return device['id'];
      });
    }
    this.selectedDevices = [];

    this.teltonikaService.rebootDevices(selectedIds, this.allDevicesSelected ? { TagID: this.id, Search: this.searchTerm == "" ? null : this.searchTerm, ...this.appliedFilters } : null).subscribe({
    });
    this.allDevicesSelected = false;
    this.devicesTable.ClearSelection();
    this.sharedGenericService.service.createToast('Devices Rebooting', 'Reboot command sent', 'info');

    // this.showTable = true;
  }

  runTeltonikaTask() {
    const dialogRef = this.dialog.open(TeltonikaExecuteTaskModalComponent, {
      width: '500px',
      maxHeight: '600px',
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result != null) {
        if (result.TaskID == null) {
          return;
        } else {
          let deviceIDs: number[] = [];
          if (this.allDevicesSelected) {
            deviceIDs = this.selectedDevices.map((device) => device["id"]);
          }
          this.teltonikaService.executeTeltonikaTask(result.TaskID, deviceIDs, this.allDevicesSelected ? { TagID: this.id, Search: this.searchTerm == "" ? null : this.searchTerm, ...this.appliedFilters } : null).subscribe({
            next: (resp) => {
              const sessionGuid = resp.SessionGUID

              this.toastr.success('Task is being executed');

              const dialogRef = this.dialog.open(TeltonikaTaskPollingModalComponent, {
                width: '60vw',
                data: { sessionGuid: sessionGuid, taskId: result.TaskID, devices: this.selectedDevices.map((device) => { return { Name: device["TeltonikaCustomName"], ID: device["id"], Serial: device["name"], Status: TeltonikaTaskState.loading } }) }
              });

              this.dialogService.RegisterDialog(dialogRef);
              dialogRef.afterClosed().subscribe((result) => {
                this.dialogService.DeRegisterDialog(dialogRef);
              });
            },
            error: (err) => {
              this.toastr.error('Error starting execution');
            }
          });
        }
      }
    });
  };

  selectedContainsDisabledDevice() {
    return this.selectedDevices.some(device => {
      return device["TeltonikaStatus"] !== "Online";
    });
  }

  buildHTTPData() {
    let deviceTypes: { name: string }[] | null = null;
    if (this.appliedFilters.Model != null) {
      deviceTypes = [{ name: this.appliedFilters.Model }];
    }
    return { TeltonikaTagIsNull: false, TeltonikaTagID: this.id, TeltonikaReachable: this.appliedFilters.DeviceStatus, DeviceTypes: deviceTypes, TeltonikaFirmware: this.appliedFilters.Firmware };
  }
}
